module.exports = __webpack_public_path__ + "img/d_link.3fd8ea41.svg";